/**
 * Luvia Scroll Animations
 * Intersection Observer pour animations au scroll
 * Léger, performant, respecte prefers-reduced-motion
 */

(function() {
  'use strict';

  // Sélecteur centralisé (évite la duplication)
  const SCROLL_SELECTOR = '[data-scroll], [data-scroll-stagger], [data-scroll-header]';

  // Respect reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    document.querySelectorAll(SCROLL_SELECTOR).forEach(el => el.classList.add('is-visible'));
    return;
  }

  // Configuration
  const config = {
    threshold: 0.15,
    rootMargin: '0px 0px -50px 0px'
  };

  // Callback pour l'observer
  const handleIntersection = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        if (!entry.target.hasAttribute('data-scroll-repeat')) {
          observer.unobserve(entry.target);
        }
      } else if (entry.target.hasAttribute('data-scroll-repeat')) {
        entry.target.classList.remove('is-visible');
      }
    });
  };

  // Créer l'observer
  const observer = new IntersectionObserver(handleIntersection, config);

  // Observer tous les éléments
  const animatedElements = document.querySelectorAll(SCROLL_SELECTOR);
  animatedElements.forEach(el => observer.observe(el));

  // Support Shopify Section Rendering API
  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll(SCROLL_SELECTOR).forEach(el => {
        el.classList.remove('is-visible');
        observer.observe(el);
      });
    });
  }

  // Marquer les éléments above the fold comme visibles immédiatement
  requestAnimationFrame(() => {
    animatedElements.forEach(el => {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.8) {
        el.classList.add('is-visible');
      }
    });
  });
})();
